import React from "react";
import { Entry } from "contentful";
import {
  BrandInvestmentPerks,
  BrandInvestmentSinglePerk,
} from "@tiicker/util/lib/contentful/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/sharp-light-svg-icons";
import styles from "./Perks.module.scss";
import Markdown from "components/Markdown/Markdown";
import { triggerInvestCTAClick } from "source/analytics-events";

type Props = {
  perkSection?: Entry<BrandInvestmentPerks>;
  symbol: string;
};

const Perks: React.FC<Props> = ({ perkSection, symbol }) => {
  if (!perkSection?.fields) return null;

  const { title, titleHex, description, perks } = perkSection.fields;

  const handlePerkClick = (perk: Entry<BrandInvestmentSinglePerk>) => {
    triggerInvestCTAClick(symbol);
    if (perk.fields.cardUrl) {
      // Add https:// if not present
      let url = perk.fields.cardUrl;
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = `https://${url}`;
      }
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className={styles.Perks}>
      <div className={styles.Perks__header}>
        <h2 className={styles.Perks__title} style={{ color: titleHex }}>
          {title}
        </h2>
        <Markdown
          markdownText={description}
          className={styles.Perks__description}
        />
      </div>

      <div className={styles.Perks__grid}>
        {perks?.map((perk, index) => (
          <div
            key={perk.sys.id}
            className={styles.Perks__item}
            onClick={() => handlePerkClick(perk)}
          >
            <div className={styles.Perks__item__imageWrapper}>
              <img
                src={perk.fields.perkImage.fields.file.url}
                alt={perk.fields.title}
                className={styles.Perks__item__image}
              />
            </div>
            <div className={styles.Perks__item__content}>
              <div className={styles.Perks__item__titleRow}>
                <h3 className={styles.Perks__item__title}>
                  {perk.fields.title}
                </h3>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className={styles.Perks__item__arrow}
                  style={{ color: perk.fields.arrowHex }}
                />
              </div>
              <div className={styles.Perks__item__value}>
                Share Value: {perk.fields.perkValue}
              </div>
              <p className={styles.Perks__item__description}>
                {perk.fields.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Perks;
